import type { FC, ReactElement } from 'react';
import React, { useMemo } from 'react';

import { BetLimitsConnected } from '@pp/core/src/components/betLimits/BetLimitsConnected';
import type { BetLimitData } from '@pp/core/src/components/betLimits/types';
import { Loader } from '@pp/core/src/components/loader/Loader';
import { MaxPayoutText } from '@pp/core/src/components/maxPayoutText/MaxPayoutText';
import { CurrencyFormatter } from '@pp/core/src/formatters/CurrencyFormatter';
import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';
import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';
import { useSettingsSlice } from '@pp/core/src/store/slices/settings/selectors';
import { formatNumber } from '@pp/core/src/utils/formatters';

import { Bets } from '../../config/bets';
import { useGameConfigSlice } from '../../store/slices/config/selectors';
import { HIGHFLYER_PT } from '../../config';

export const HighflyerBetLimitsConnected: FC = (): ReactElement => {

  const { betLimits, tableVariant } = useConfigSlice.tableConfig() ?? {};
  const maxMultiplier = useGameConfigSlice.getMaxMultiplier();
  const locale = useSettingsSlice.currentLanguage();
  const perPayoutBetMaxLimit = useGameConfigSlice.getPerPayoutBetMaxLimit();
  const formattedMaxPayout = CurrencyFormatter.format(perPayoutBetMaxLimit, locale, {
    currency: 'EUR',
    avoidTrailingZero: true,
  });

  const betLimitData = useMemo(() => {
    if (!betLimits) return null;
    const data: BetLimitData[] = [
      {
        name: <L10nText tk="BETLABEL" key="1" />,
        limits: [betLimits[Bets.ONE].min, betLimits[Bets.ONE].max],
        payout: `1.01x - ${formatNumber(locale, Number(maxMultiplier)) || 0}x`,
      },
    ];

    return data;
  }, [betLimits]);

  if (!betLimitData) {
    return <Loader />;
  } else
    return (
      <BetLimitsConnected
        betLimitData={betLimitData}
        footNotes={tableVariant === HIGHFLYER_PT ? [<></>] : [
          <MaxPayoutText
            key="footer1-1"
            tk="MAXIMUM_PAYOUT_V5"
            dynamicValues={[`${formatNumber(locale, Number(maxMultiplier)) || 0}`, formattedMaxPayout || '']}
          />,
        ]}
      />
    );
};
